import React, { useState } from "react";
import { Star } from "lucide-react";

const LABELS = ["", "Poor", "Fair", "Good", "Very good", "Exceptional"];

export function StarPicker({ value, onChange, size = 30 }) {
  const [hover, setHover] = useState(0);
  const active = hover || value;
  return (
    <div className="flex items-center gap-3" data-testid="review-star-picker">
      <div className="flex" role="radiogroup" aria-label="Your rating" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((i) => (
          <button
            key={i}
            type="button"
            role="radio"
            aria-checked={value === i}
            aria-label={`${i} star${i > 1 ? "s" : ""}`}
            data-testid={`review-star-${i}`}
            onMouseEnter={() => setHover(i)}
            onClick={() => onChange(i)}
            className="p-0.5 transition-transform duration-200 hover:scale-110"
          >
            <Star style={{ width: size, height: size }} strokeWidth={1.4} className={i <= active ? "fill-gold text-gold" : "text-gold/30"} />
          </button>
        ))}
      </div>
      <span className="min-w-[80px] text-[11px] uppercase tracking-widest text-muted-foreground">{LABELS[active]}</span>
    </div>
  );
}
